"use client"

import { useTranslations } from "next-intl"
import Link from "next/link"

import { useGetLocale } from "@/shared/hooks/useGetLocale"
import { MapPinIcon, Typography } from "@/shared/ui/atoms"
import { DirectionIcon, SearchIcon } from "@/shared/ui/atoms"

const SearchButton = () => {
  const locale = useGetLocale()
  const t = useTranslations()

  return (
    <>
      <div className="pt-[30px] pb-[40px] px-4">
        <Link href={`/${locale}/search`} className="w-full flex items-center py-2 px-4 gap-3 bg-white rounded-[14] border border-primary-600">
          <SearchIcon size={24} className="text-gray-900" />
          <Typography size={16} lineHeight={20} className="text-gray-400">{t("commonSearch.placeholder")}</Typography>
        </Link>
        <Link href={`/${locale}/search?modal=region`} className="w-fit mt-4 rounded-full border border-[primary-600] bg-white flex items-center justify-between py-2 px-3">
          <div className="flex items-center gap-1 ml-[1px]">
            <MapPinIcon size={16} className="text-primary-700" />
            <Typography size={14} lineHeight={14} className="font-medium">
              {t("commonRegionModal.title")}
            </Typography>
          </div>
          <DirectionIcon
            size={14}
            rotate={270}
            className="text-gray-500"
          />
        </Link>
      </div>
    </>
  )
}

export default SearchButton
